import { render, staticRenderFns } from "./speech.vue?vue&type=template&id=6b21ed12&scoped=true"
import script from "./speech.vue?vue&type=script&lang=js"
export * from "./speech.vue?vue&type=script&lang=js"
import style0 from "./speech.vue?vue&type=style&index=0&id=6b21ed12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b21ed12",
  null
  
)

export default component.exports